import React from 'react';
import classNames from 'classnames';

import styles from './PrePageFilters.module.scss';

const PrePageFilters = ({ filters, setState, state }) => (
  <div className={styles.cont}>
    {filters.map((filter) => (
      <>
        {filter === 'all' && <div className={styles.divider} />}
        <button
          key={filter}
          className={classNames(styles.pageFilterButton, state === filter && styles.active)}
          type="button"
          onClick={() => setState(filter)}
        >
          {filter}
        </button>
      </>
    ))}
  </div>
);

export default PrePageFilters;
